import "./analytics/initAmplitude";
import "./analytics/initPostHog";
import "./utils/suppressStripeTelemetryConsole";
import { startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";
import { setupChunkErrorHandler } from "./utils/chunkErrorHandler";
import { initPushTokenListener } from "./api/auth/pushToken";
import { captureReferralCodeFromLocation } from "./api/auth/referralCapture";
import { getSiteEnteredAt } from "./config/annualDiscountPromo";
import i18n, { loadLanguage } from "./i18n/i18n";
import { splitLocalePath } from "./i18n/localePath";

// Browser-only bootstrap that used to live in main.tsx.

// Handle chunk load errors before the app's error boundary mounts.
setupChunkErrorHandler();

// Listen for the FCM push token injected by the native Flutter WebView wrapper.
// In a normal browser this event never fires, so this is a harmless no-op.
initPushTokenListener();
captureReferralCodeFromLocation();
// Start the 30s count for the discount popup from the moment the visitor lands.
getSiteEnteredAt();

// Clean cache-busting param from URL after reload.
if (window.location.search.includes("_refresh=")) {
  const url = new URL(window.location.href);
  url.searchParams.delete("_refresh");
  window.history.replaceState(window.history.state, "", url.pathname + url.search);
}

// The server rendered the URL's language; switch to it before hydrating so
// the first browser render matches the HTML.
const prepareLanguage = async () => {
  const urlLocale = splitLocalePath(window.location.pathname).locale;
  if (urlLocale && urlLocale !== "en") {
    await loadLanguage(urlLocale);
    await i18n.changeLanguage(urlLocale);
  }
};

void prepareLanguage().then(() => startTransition(() => {
  hydrateRoot(document, <HydratedRouter />, {
    // A mismatch between server HTML and the first browser render. React
    // recovers by re-rendering in the browser; log where it happened.
    onRecoverableError(error, info) {
      console.error("Hydration error", error, info.componentStack);
    },
  });
}));
